export default __webpack_public_path__ + "static/media/icons8-american-express.3d37f804.svg";